export default __webpack_public_path__ + "static/Agile-development-693bff3314508de644dd815e0d7bef7a.webp";